import { useEffect, useState } from 'react';
import { demeterApi } from '../../../../../Apis/Apis';
import { DemeterCommodity, InsuranceState } from '../../../../../Generated/Raven-Demeter/api';
import useApi from '../../../../Apis/Hooks/useApiHook';
import useApiWithoutAutoExecute from '../../../../Apis/Hooks/useApiWithoutAutoExecute';
import PageLoadingSpinner from '../../../../Components/LoadingSpinner/PageLoadingSpinner';
import formattingService from '../../../../Services/Formatting/FormattingService';
import { LiquidityRiskCalculationInputs } from '../../RiskDefinitions';
import CoverageLevels from './CoverageLevels';
import LivestockRevenueProtectionForm from './LivestockRevenueProtectionForm';

const defaultInsuranceState = InsuranceState.Alabama;
const defaultCommodity = DemeterCommodity.CattleFeeder;
const defaultInsuredSharedPercentage = 100;
const defaultEndorsementLength = [13];
const defaultEndWeight = 5;
const defaultAnimalHeadCount = 1;
const defaultCostPerPoundOfGrain = 0;
const defaultShortWeight = 0;
const defaultPurchaseCostPerAnimal = 0;

const LivestockRevenueProtection: React.FC = () => {
    // Display hooks.
    const [tableCalculations, setTableCalculations] = useState<boolean>(false);
    const [calculationInputs, setCalculatorInputs] = useState<LiquidityRiskCalculationInputs>();

    const [, refreshListLivestockInsurancePrices, listLivestockInsurancePricesResponse] = useApiWithoutAutoExecute(() =>
        demeterApi.listLivestockInsurancePrices(
            calculationInputs!.insuranceYear,
            calculationInputs!.coverageEffectiveDate,
            calculationInputs!.insuranceState,
            calculationInputs!.commodity,
            calculationInputs!.type,
            calculationInputs!.endorsementLength,
        ),
    );

    const [, , listLivestockInsurancePriceDatesResponse] = useApi(() => demeterApi.listLivestockInsurancePriceDates());

    const sortedListLivestockInsurancePriceDatesResponse = {
        ...listLivestockInsurancePriceDatesResponse,
        rows: listLivestockInsurancePriceDatesResponse
            ?.rows!.sort((a, b) => b.reinsuranceYear - a.reinsuranceYear)
            .map((x) => ({
                ...x,
                asOfDates: x.asOfDates.sort((a, b) => new Date(b).getTime() - new Date(a).getTime()),
            })),
    };

    useEffect(() => {
        if (calculationInputs || !sortedListLivestockInsurancePriceDatesResponse?.rows) {
            return;
        }

        setCalculatorInputs({
            insuranceYear: sortedListLivestockInsurancePriceDatesResponse!.rows![0].reinsuranceYear,
            coverageEffectiveDate: formattingService.toApiDate(sortedListLivestockInsurancePriceDatesResponse!.rows![0].asOfDates[0]),
            insuredSharedPercentage: defaultInsuredSharedPercentage,
            endorsementLength: defaultEndorsementLength,
            endWeight: defaultEndWeight,
            insuranceState: defaultInsuranceState,
            commodity: defaultCommodity,
            type: [],
            animalHeadCount: defaultAnimalHeadCount,
            costPerPoundOfGrain: defaultCostPerPoundOfGrain,
            shortWeight: defaultShortWeight,
            purchaseCostPerAnimal: defaultPurchaseCostPerAnimal,
        });
    }, [sortedListLivestockInsurancePriceDatesResponse]);

    const loading = !calculationInputs;

    return loading ? (
        <PageLoadingSpinner />
    ) : (
        <>
            <LivestockRevenueProtectionForm
                tableCalculations={tableCalculations}
                setTableCalculations={setTableCalculations}
                calculationInputs={calculationInputs}
                setCalculatorInputs={setCalculatorInputs}
                refreshListLivestockInsurancePrices={refreshListLivestockInsurancePrices}
                listLivestockInsurancePriceDatesResponse={sortedListLivestockInsurancePriceDatesResponse!}
            />
            <CoverageLevels
                calculationInputs={calculationInputs!}
                listLivestockInsurancePricesResponse={listLivestockInsurancePricesResponse}
                accordionOpen={tableCalculations}
            />
        </>
    );
};

export default LivestockRevenueProtection;
